import { render, staticRenderFns } from "./refundOrderItem1.vue?vue&type=template&id=231581ff"
import script from "./refundOrderItem1.vue?vue&type=script&lang=js"
export * from "./refundOrderItem1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports